import React from "react";
import { constants } from "@qgiv/core-js";
import { useSelector } from "react-redux";
import { selectBaseUrl } from "../redux/slices/p2pSettingsSlice";
import { selectFormStatus } from "../redux/slices/appSettingsSlice";
import UpdateNavigation from "./UpdateNavigation";

const ConnectedUpdateNavigation = () => {
    const {
        ENUMS: { FormStatusType },
    } = constants;
    const baseUrl = useSelector(selectBaseUrl);
    const formStatus = useSelector(selectFormStatus);
    const registrationAvailable =
        formStatus === FormStatusType.REGISTRATION_AVAILABLE;
    return (
        <UpdateNavigation
            baseUrl={baseUrl}
            registrationAvailable={registrationAvailable}
        />
    );
};

export default ConnectedUpdateNavigation;
